import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  gap: 64px;
  align-items: center;
  padding-bottom: 120px;
`

export const Left = styled.div`
`

export const Title = styled.h1`
  color: #FFF;
  font-size: 96px;
  font-weight: 800;
  text-align: left;
`

export const Photo = styled.img`
  width: 710px;
`